export const PLUGIN_NAME = 'com.msgbyte.notify';

export const PLUGIN_SYSTEM_SETTINGS_DISABLED_SOUND = `${PLUGIN_NAME}.disabledSound`;
